export default __webpack_public_path__ + "static/media/sunny.fe43aa15.jpg";